// Email validation utility functions

export interface EmailValidationResult {
  isValid: boolean;
  message: string;
}

export const validateEmail = (email: string): EmailValidationResult => {
  const trimmedEmail = email.trim().toLowerCase();
  
  // Check for empty email
  if (!trimmedEmail) {
    return {
      isValid: false,
      message: 'Please enter your email address'
    };
  }
  
  // Check for basic email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmedEmail)) {
    return {
      isValid: false,
      message: 'Please enter a valid email address.'
    };
  }
  
  // Check for obviously invalid emails
  const invalidEmails = [
    'test@test.com',
    'test@example.com',
    'd@d.com',
    'a@a.com',
    'test@test',
    'test.com',
    'test@',
    '@test.com',
    'test@.com',
    'test@test.',
    'test@@test.com',
    'test@test..com'
  ];
  
  if (invalidEmails.includes(trimmedEmail)) {
    return {
      isValid: false,
      message: 'Please enter a valid email address.'
    };
  }
  
  // Check for disposable email domains (common ones)
  const disposableDomains = [
    '10minutemail.com',
    'guerrillamail.com',
    'mailinator.com',
    'tempmail.org',
    'throwaway.email',
    'yopmail.com',
    'getnada.com',
    'mailnesia.com',
    'sharklasers.com',
    'grr.la',
    'guerrillamailblock.com',
    'pokemail.net',
    'spam4.me',
    'bccto.me',
    'chacuo.net',
    'dispostable.com',
    'fakeinbox.com',
    'fakeinbox.net',
    'fakemailgenerator.com',
    'getairmail.com',
    'maildrop.cc',
    'mailmetrash.com',
    'mailnesia.com',
    'mailnull.com',
    'mintemail.com',
    'mytrashmail.com',
    'nwldx.com',
    'sharklasers.com',
    'spamspot.com',
    'spam.la',
    'temp-mail.org',
    'tempr.email',
    'tmpeml.com',
    'tmpmail.net',
    'tmpmail.org',
    'trashmail.com',
    'trashmail.net',
    'trashmailer.com',
    'wegwerfemail.de',
    'wegwerfemail.net',
    'wegwerfemail.org'
  ];
  
  const emailDomain = trimmedEmail.split('@')[1];
  if (disposableDomains.includes(emailDomain)) {
    return {
      isValid: false,
      message: 'Please use a valid email address. Disposable email addresses are not allowed.'
    };
  }
  
  return {
    isValid: true,
    message: ''
  };
};

export const sanitizeEmail = (email: string): string => {
  return email.trim().toLowerCase();
}; 